<template>
  <section class="prez">
    <!-- Left: president photo -->
    <div class="prez__left">
      <img src="../../assets/img/images/prezident.png" :alt="$t('home.prezidentName')" class="prez__photo" />
    </div>

    <!-- Right: building backdrop -->
    <div class="prez__right">
      <img src="../../assets/img/images/asidebuilding.png" alt="" class="prez__bg" />
    </div>

    <!-- Full-width dark gradient for quote readability -->
    <div class="prez__overlay"></div>

    <!-- Quote content (starts just left of center) -->
    <div class="prez__content">
      <img src="../../assets/img/logos/quotes.png" alt="" class="prez__qmark" />
      <p class="prez__quote">{{ $t('home.prezidentQuote') }}</p>
      <div class="prez__author">
        <img src="../../assets/img/logos/uzb_gerb.png" alt="" class="prez__emblem" />
        <div class="prez__author-text">
          <span class="prez__name">{{ $t('home.prezidentName') }}</span>
          <span class="prez__role">{{ $t('home.prezidentRole') }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrezidentPart'
}
</script>

<style lang="scss">
@import '../../styles/components/03prezident/prezident.scss';
</style>
